import qs from "qs";
import { AxiosQuery } from "../api/AxiosQuery";
import {
  ReservacionFormModel,
  ReservacionParticipanteModel,
} from "../models/ReservacionModel";

export const getListaReservacionService = async () => {
  let query = qs.stringify(
    {
      fields: ["id", "titulo", "descripcion", "fecha_inicio", "fecha_fin"],
      filters: { eliminado: false },
      populate: {
        espacio: {
          fields: ["id", "nombre"],
        },
        reservado_por: {
          fields: ["id", "nombre", "email"],
        },
        reservado_para: {
          fields: ["id", "nombre", "email"],
        },
        participantes: {
          populate: {
            participante: {
              fields: ["id", "nombre", "email"],
            },
          },
        },
      },
      pagination: {
        pageSize: 9999,
      },
      sort: ["id:desc"],
    },
    {
      encodeValuesOnly: true,
    }
  );

  return await AxiosQuery("GET", "/api/reservaciones", query);
};

export const saveReservacionFormService = async (
  reservacionForm: ReservacionFormModel
) => {
  let query = qs.stringify(
    {
      fields: ["id"],
    },
    {
      encodeValuesOnly: true,
    }
  );

  return await AxiosQuery("POST", "/api/reservaciones", query, {
    data: reservacionForm,
  });
};

export const saveReservacionParticipanteService = async (
  reservacionParticipante: ReservacionParticipanteModel
) => {
  let query = qs.stringify(
    {
      fields: ["id"],
      populate: "*",
    },
    {
      encodeValuesOnly: true,
    }
  );
  return await AxiosQuery(
    "POST",
    "/api/createManyParticipantes",
    query,
    reservacionParticipante
  );
};

export const updateReservacionFormService = async (
  reservacionForm: ReservacionFormModel
) => {
  return await AxiosQuery(
    "PUT",
    "/api/reservaciones/" + reservacionForm.id,
    "",
    { data: reservacionForm }
  );
};

export const removeReservacionService = async (id: number) => {
  return await AxiosQuery("DELETE", "/api/reservaciones/" + id, "");
};

export const removeReservacionSoftService = async (id: number, data: any) => {
  return await AxiosQuery("PUT", `/api/eliminar-reservacion/${id}`, "", data);
};
